@charset "UTF-8";

/* apps/fourcomply-dashboard/src/app/shared/components/header/header.component.scss */
div.height70 {
  height: 70px;
}
#logoImg {
  width: 180px;
  height: auto;
  margin-top: 15px;
}
.header-area {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: var(--background-white);
  border-bottom: 1px solid var(--background-border);
  height: 70px;
}
.header-area .navbar-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  height: 100%;
  gap: var(--space-sm);
}
.header-area .navbar-section + .navbar-section {
  justify-content: flex-end;
  margin-left: auto;
}
.header-area .header-actions {
  align-items: center;
  display: inline-flex;
  gap: 2px;
}
.header-area .header-actions .tenant-ghost-btn {
  margin-right: var(--space-xs);
}
.header-area img {
  height: auto;
  max-width: 100%;
}
.header-area .btn.btn-link {
  align-items: center;
  color: var(--text-primary);
  display: inline-flex;
  font-size: 18px;
  height: 40px;
  justify-content: center;
  padding: 0;
  transition: background var(--transition-fast), color var(--transition-fast);
  width: 40px;
}
.header-area .btn.btn-link:hover {
  background: var(--background-light);
  color: #000;
}
.header-area .btn.btn-link i {
  font-size: 20px;
}
.lang-flag-btn {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  color: var(--text-muted);
  cursor: pointer;
  display: inline-flex;
  gap: 4px;
  height: 40px;
  margin: 0 2px;
  padding: 0 6px;
  transition: background var(--transition-fast);
}
.lang-flag-btn:hover {
  background: var(--background-light);
}
.lang-flag-btn:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}
.lang-flag-btn .lang-flag-img {
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
  height: 16px;
  width: auto;
}
.lang-flag-btn .lang-chevron {
  font-size: 10px;
}
.tenant-ghost-btn {
  align-items: center;
  background: var(--background-light);
  border: 1px solid transparent;
  border-radius: var(--radius-lg);
  color: var(--text-primary);
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 500;
  gap: var(--space-sm);
  height: 40px;
  padding: 0 12px;
  transition: background var(--transition-fast), border-color var(--transition-fast);
  white-space: nowrap;
}
.tenant-ghost-btn:hover {
  background: var(--background-lighter);
}
.tenant-ghost-btn:focus-visible {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(97, 119, 143, 0.18);
}
.tenant-ghost-btn .tenant-name {
  font-weight: 600;
}
.tenant-ghost-btn .tenant-chevron {
  color: var(--text-muted);
  font-size: 11px;
  margin-left: var(--space-xs);
}
::ng-deep .header-ghost-menu.mat-mdc-menu-panel {
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  margin-top: var(--space-xs);
  min-width: 240px;
}
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-content {
  padding: 6px;
}
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-item {
  border-radius: var(--radius-md);
  font-size: 13.5px;
  height: 36px;
  line-height: 1;
  min-height: 36px;
  padding: 0 10px;
}
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-item.is-active {
  background: rgba(97, 119, 143, 0.1);
}
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-item .mat-mdc-menu-item-text,
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-item .mdc-list-item__primary-text {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  font-size: inherit;
  gap: 0;
  line-height: 1;
  min-width: 0;
}
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-item .menu-flag,
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-item .lang-flag-img.menu-flag {
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
  flex: 0 0 auto;
  height: 14px;
  margin-right: var(--space-sm);
  width: auto;
}
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-item .menu-label {
  align-items: baseline;
  display: inline-flex;
  flex: 1 1 auto;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-item .menu-label .tenant-name {
  font-weight: 600;
}
::ng-deep .header-ghost-menu.mat-mdc-menu-panel .mat-mdc-menu-item .menu-check {
  color: var(--primary-color);
  flex: 0 0 auto;
  font-size: 12px;
  margin-left: auto;
  padding-left: var(--space-sm);
}
::ng-deep .header-ghost-menu.tenant-menu .mat-mdc-menu-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
::ng-deep .header-ghost-menu.tenant-menu .tenant-add {
  color: var(--primary-color);
  font-weight: 500;
  margin-top: var(--space-xs);
}
::ng-deep .header-ghost-menu.tenant-menu .tenant-add .menu-flag {
  background: transparent;
  box-shadow: none;
  color: var(--primary-color);
  font-size: 12px;
  margin-right: var(--space-sm);
}
.user-menu-btn {
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-lg);
  color: var(--text-primary);
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 13.5px;
  gap: var(--space-sm);
  height: 40px;
  margin-left: var(--space-xs);
  padding: 0 10px 0 4px;
  transition: background var(--transition-fast);
}
.user-menu-btn:hover {
  background: var(--background-light);
}
.user-menu-btn:focus-visible {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px var(--primary-color-light);
  outline: none;
}
.user-menu-btn .um-name {
  font-weight: 600;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-menu-btn .um-chevron {
  color: var(--text-muted);
  font-size: 11px;
}
.um-initials {
  align-items: center;
  background: var(--primary-color);
  border-radius: 50%;
  color: var(--background-white);
  display: inline-flex;
  flex: 0 0 30px;
  font-size: 11.5px;
  font-weight: 700;
  height: 30px;
  justify-content: center;
  line-height: normal;
  width: 30px;
}
.um-initials.lg {
  flex: 0 0 40px;
  font-size: 14.5px;
  height: 40px;
  width: 40px;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel {
  max-width: 320px;
  min-width: 288px;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .um-head {
  align-items: center;
  border-bottom: 1px solid var(--background-border);
  display: flex;
  gap: var(--space-sm);
  margin: 0 0 var(--space-xs);
  padding: var(--space-md);
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .um-id {
  min-width: 0;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .um-full {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .um-email {
  color: var(--text-secondary);
  font-size: 12.5px;
  line-height: 1.4;
  word-break: break-word;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .um-role {
  background: var(--primary-color-light);
  border-radius: var(--radius-sm);
  color: var(--primary-color-dark);
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  margin-top: var(--space-xs);
  padding: 2px 7px;
  text-transform: uppercase;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-content {
  padding: var(--space-xs) 0;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item {
  border: 0;
  border-radius: 0;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 500;
  height: 46px;
  min-height: 46px;
  padding: 0 var(--space-md);
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item:hover {
  background: var(--background-light);
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item .mat-ripple,
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item .mat-mdc-menu-ripple,
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item .mat-mdc-focus-indicator,
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item::before,
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item::after {
  border-radius: 0;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item .mat-mdc-focus-indicator::before {
  border: 0;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item:focus,
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item.cdk-program-focused,
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item.cdk-mouse-focused {
  background: transparent;
  outline: none;
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item.cdk-keyboard-focused,
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item.cdk-program-focused:hover,
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item.cdk-mouse-focused:hover,
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item:focus:hover {
  background: var(--background-light);
}
::ng-deep .header-ghost-menu.user-menu.mat-mdc-menu-panel .mat-mdc-menu-item .um-item-icon {
  color: var(--text-primary);
  font-size: 15px;
  margin-right: 12px;
  text-align: center;
  width: 18px;
}
.menu-toggle-button {
  position: absolute;
  top: 35px;
  transform: translateY(-50%);
  background-color: var(--background-white);
  border: 1px solid var(--background-border);
  padding: 5px 5px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  z-index: 1000;
  transition: left var(--transition-normal);
  left: 250px;
}
.menu-toggle-button i {
  font-size: 20px;
  color: var(--text-primary);
  transition: color var(--transition-normal);
}
.menu-toggle-button i:hover {
  color: #000;
}
@media (max-width: 768px) {
  .header-area .navbar-section {
    padding: 0 10px;
    height: 70px;
  }
  .header-area .menu-toggle-button {
    left: 130px;
  }
  .user-menu-btn .um-name {
    display: none;
  }
}
.pw-modal-content {
  max-width: 460px;
  min-width: 380px;
}
.pw-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-bottom: var(--space-md);
}
.pw-field .pw-field-label {
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 700;
}
.pw-field .pw-field-label .req {
  color: var(--error-red);
}
.pw-field .pw-input {
  background: var(--background-white);
  border: 1px solid var(--background-border);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-family: inherit;
  font-size: 14px;
  outline: none;
  padding: 10px 12px;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  width: 100%;
}
.pw-field .pw-input:hover {
  border-color: var(--text-light);
}
.pw-field .pw-input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px var(--primary-color-light);
}
.pw-field.invalid .pw-input {
  border-color: var(--error-red);
}
.pw-field.invalid .pw-input:focus {
  box-shadow: 0 0 0 3px var(--error-red-light);
}
.pw-field-error {
  color: var(--error-red);
  font-size: 12px;
  font-weight: 600;
}
.pw-server-error {
  margin-top: var(--space-sm);
}
.pw-rules {
  display: flex;
  flex-direction: column;
  gap: 5px;
  list-style: none;
  margin: 0 0 var(--space-sm);
  padding: 0;
}
.pw-rules li {
  align-items: center;
  color: var(--text-secondary);
  display: flex;
  font-size: 12.5px;
  gap: var(--space-sm);
}
.pw-rules li i {
  font-size: 9px;
  width: 12px;
}
.pw-rules li.met {
  color: var(--text-primary);
}
.pw-rules li.met i {
  color: var(--success-green);
  font-size: 11px;
}
.pw-modal-foot {
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: var(--space-lg);
}
.pw-btn {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 7px;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  gap: 7px;
  padding: 7px 14px;
  transition:
    background var(--transition-fast),
    box-shadow var(--transition-fast),
    opacity var(--transition-fast);
}
.pw-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.pw-btn.ghost {
  background: var(--background-white);
  border-color: var(--background-border);
  color: var(--text-primary);
}
.pw-btn.ghost:hover {
  background: var(--background-light);
}
.pw-btn.primary {
  background: var(--primary-color);
  color: var(--background-white);
}
.pw-btn.primary:hover {
  background: var(--primary-color-hover);
}
/*# sourceMappingURL=header.component.css.map */
